/**
 * Lectura de la respuesta del crud. Módulo hoja a propósito: `utils.js` arrastra el store, axios y
 * posthog, y estas tres funciones son las que los tests importan reales (`jest.requireActual`) en
 * lugar de copiarlas; `utils.js` las reexporta, así que los imports existentes siguen valiendo.
 */

type ValidationError = { code: string };

export type CrudErrorResponse = {
  status?: number;
  data?: { results?: { errors?: ValidationError[] } };
};

/** Respuesta resuelta por el interceptor de axios: HTTP normal o `{ error }` (`crud.md`). */
export type CrudResponse = {
  status?: number;
  data?: { status?: string };
  error?: CrudErrorResponse;
};

export function successResponse(response: CrudResponse): boolean {
  return response.status === 200 && !!response.data && response.data.status === 'success';
}

/** Status HTTP de una respuesta del crud, también cuando el interceptor la resuelve como `{ error }`. */
export function getResponseStatus(response: CrudResponse): number | undefined {
  return response.status ?? response.error?.status;
}

export function hasValidationErrorCode(response: CrudResponse | null | undefined, code: string): boolean {
  const errors = response?.error?.data?.results?.errors ?? [];
  return errors.some((error) => error.code === code);
}
